import isEqual from 'lodash/isEqual';
import uniqueId from 'lodash/uniqueId';

import {events} from '@edna/utils';

import {EEvent} from '../types';
import {
  DUPLICATE_IGNORE_DURATION,
  ENotificationType,
  TNewNotification,
  TNewNotificationOptions,
} from './types';

const showNewNotification = (notification: TNewNotificationOptions) =>
  events.trigger(EEvent.ADD_NEW_NOTIFICATION, notification);

const hideNewNotification = (id: TNewNotification['id']) =>
  events.trigger(EEvent.REMOVE_NEW_NOTIFICATION, id);

const compareNotifications = (
  firstNotification: TNewNotificationOptions,
  secondNotification: TNewNotificationOptions,
) =>
  firstNotification.id === secondNotification.id ||
  (firstNotification.title === secondNotification.title &&
    firstNotification.message === secondNotification.message &&
    firstNotification.messageKey === secondNotification.messageKey &&
    isEqual(firstNotification.messageArgs, secondNotification.messageArgs));

const checkForDuplicates = (list: TNewNotification[], item: TNewNotificationOptions) =>
  list.some(({id}) => id === item.id) ||
  list
    .filter(({createdAt}) => Date.now() - createdAt < DUPLICATE_IGNORE_DURATION)
    .some((current) => compareNotifications(current, item));

const createNotification = (notification: TNewNotificationOptions) => ({
  id: notification.id ?? uniqueId(),
  ...notification,
  createdAt: Date.now(),
});

const isDarkNotification = (type: TNewNotification['type']) =>
  [ENotificationType.WARNING, ENotificationType.warning].includes(type as ENotificationType);

export {
  showNewNotification,
  hideNewNotification,
  createNotification,
  checkForDuplicates,
  isDarkNotification,
};
